<template>
  <div class="export-base-map-button" @click="exportLayerFn" title="底图服务导出">
    <svg-icon iconName="download-center"></svg-icon>
  </div>
  <teleport to="#home-body">
    <ExportLayer v-if="exportLayerShowFlag" :target="exportLayerTarget"
      @close="exportLayerShowFlagChange(false)">
    </ExportLayer>
  </teleport>
</template>

<script setup>
import { ref } from 'vue';
import ExportLayer from '@/views/Home/component/ManagePanel/components/SelectedTreeTable/components/ExportLayer';

const props = defineProps({
  mapItem: { type: Object, required: true },
});

const exportLayerShowFlag = ref(false);
const exportLayerTarget = ref();

const exportLayerShowFlagChange = (flag) => {
  exportLayerShowFlag.value = flag;
  if (flag) {
    exportLayerTarget.value = {
      id: props.mapItem.mapId,
      dataList: [{
        ...props.mapItem,
        id: props.mapItem.mapId,
        name: props.mapItem.mapName || props.mapItem.name
      }],
    };
  } else {
    exportLayerTarget.value = undefined;
  }
};

const exportLayerFn = () => {
  exportLayerShowFlagChange(true);
};

defineExpose({ exportLayerFn });
</script>

<style lang='less' scoped>
.export-base-map-button{
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  .svg-icon{
    font-size: 16px;
    color: var(--fontColor_18);
    transition: color 0.2s;
    &:hover{
      color: var(--fontColor_3);
    }
  }
}
</style>
